'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAuth } from '@/lib/auth';
import { BrandedLoader } from '@/components/auth/BrandedLoader';

export default function Home() {
  const { isAuthenticated, isLoading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (isLoading) return;
    if (isAuthenticated) {
      router.replace('/en/datacenter');
    } else {
      router.replace('/en/auth/login');
    }
  }, [isAuthenticated, isLoading, router]);

  return <BrandedLoader status="Loading dashboard..." />;
}
